import styled from 'styled-components';

const StyledComp = styled.div`
    padding: clamp(32px, 6vw, 80px) clamp(16px, 4vw, 40px);
    border-bottom: 1px solid rgba(var(--greyr), 0.3);
    background-color: rgba(0, 0, 0, 0.01);

    .features-header {
      max-width: 1400px;
      margin: 0 auto clamp(48px, 6vw, 80px) auto;
      padding: 0 16px;

      h2 {
        font-size: clamp(28px, 4vw, 52px);
        line-height: 1.15;

        span {
          color: var(--grey);
        }
      }
    }

    .features-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      max-width: 1400px;
      margin: 0 auto;
      border-top: 1px solid rgba(var(--greyr), 0.3);

      @media (max-width: 999px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 640px) {
        grid-template-columns: 1fr;
      }

      .feature-card {
        padding: clamp(24px, 3vw, 40px);
        border-right: 1px solid rgba(var(--greyr), 0.3);
        display: flex;
        flex-direction: column;

        &:last-child,
        &:nth-child(3n) {
          border-right: none;
        }

        @media (max-width: 999px) {
          border-right: 1px solid rgba(var(--greyr), 0.3);
          border-bottom: 1px solid rgba(var(--greyr), 0.3);

          &:nth-child(2n) {
            border-right: none;
          }

          &:nth-child(3n) {
            border-right: 1px solid rgba(var(--greyr), 0.3);
          }
        }

        @media (max-width: 640px) {
          border-right: none !important;
          border-bottom: 1px solid rgba(var(--greyr), 0.3);

          &:last-child {
            border-bottom: none;
          }
        }

        .card-fig {
          font-size: 10px;
          letter-spacing: 0.12em;
          color: var(--grey);
          margin-bottom: clamp(32px, 4vw, 56px);
          opacity: 0.6;
        }

        .card-icon-area {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: clamp(24px, 4vw, 48px) 0;

          svg {
            width: clamp(48px, 8vw, 80px);
            height: clamp(48px, 8vw, 80px);
            opacity: 0.15;
          }
        }

        .card-body {
          margin-top: clamp(32px, 4vw, 56px);

          h3 {
            font-size: clamp(14px, 1.5vw, 16px);
            letter-spacing: 0.01em;
            margin-bottom: 10px;
            line-height: 1.3;
          }

          p {
            font-size: clamp(13px, 1.3vw, 14px);
            line-height: 1.7;
            color: var(--grey);
          }
        }
      }
    }
`;

const Comp = ({features, title, subtitle}) => {
  return (
    <StyledComp>
      <div className="features-header">
        <h2 className="serif">
          {title}{' '}
          <span>{subtitle}</span>
        </h2>
      </div>

      <div className="features-grid">
        {features.map((f, i) => (
          <div className="feature-card" key={i}>
            <div className="card-fig">{f.fig}</div>
            <div className="card-icon-area">{f.icon}</div>
            <div className="card-body">
              <h3 className="sans">{f.title}</h3>
              <p>{f.description}</p>
            </div>
          </div>
        ))}
      </div>
    </StyledComp>
  );
};

export default Comp;
